export const ru = {
    action_submit: 'Выдать',
    title: 'Выдать доступ',
};
